<template>
  <ul class="tag-list__wrapper">
    <span class="tag-list__header text-medium">Tags</span>
    <li v-for="tag in tags" :key="tag.slug" class="tag-list__tag">
      <a-tag :tag="tag" />
    </li>
  </ul>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ATag from 'shared/ATag'

export default {
  name: 'TagList',
  components: { ATag },
  props: {
    tags: propValidator([PROP_TYPES.ARRAY])
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.tag-list__wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .tag-list__header {
    color: $c--gray-dark;
    margin-right: 8px;
  }

  .tag-list__tag {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }

  @include tablet {
    flex-direction: row;
  }
}
</style>
